import styled from 'styled-components';
import { colors, breakpoints } from 'app/variables';

export const PrivacyWrapper = styled.div`
  display: none;
  padding: 2rem 0;
  font-size: 0.9rem;
  text-align: center;

  @media (min-width: ${breakpoints.mediumDesktop}) {
    display: block;
  }
`;

export const PrivacyLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: ${colors.pacificBlue};
  }
`;
